/* @flow */
import * as React from 'react';
import { observer, inject } from 'mobx-react';

import { Roles } from 'permissions/defs';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import UserStore from 'stores/UserStore';

import Calibrations from '../Calibrations/Calibrations';
import AssetsByTypeBar from '../AssetsByTypeBar/AssetsByTypeBar';
import Contracts from '../Contracts/Contracts';
import AssetsByUserType from '../AssetsByUserType/AssetsByUserType';

import styles from './UserWidgetContainer.module.scss';

type InjectedProps = {
  userStore: UserStore,
};

@inject('userStore')
@observer
export default class UserWidgetContainer extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  renderWidget = () => {
    const { userStore } = this.props;

    if (userStore.activeUser) {
      switch (userStore.activeUser.role_id) {
        case Roles.USER:
          return (
            <Calibrations
              size="canvas-50"
              widgetItem={{ position: 0, variant: 'default', widget: 'Calibrations' }}
            />
          );

        case Roles.MANAGER:
          return (
            <AssetsByTypeBar
              size="canvas-50"
              widgetItem={{ position: 0, variant: 'default', widget: 'AssetsByTypeBar' }}
            />
          );

        case Roles.PURCHASER:
          return (
            <Contracts
              size="canvas-50"
              widgetItem={{ position: 0, variant: 'default', widget: 'Contracts' }}
            />
          );

        case Roles.VIEW_ONLY:
          return (
            <AssetsByTypeBar
              size="canvas-50"
              widgetItem={{ position: 0, variant: 'default', widget: 'AssetsByTypeBar' }}
            />
          );

        case Roles.ACCOUNT_ADMIN:
        case Roles.ACCOUNT_MANAGER:
        case Roles.ASSET_MANAGER:
        case Roles.BUSINESS_VIEW_ONLY:
        case Roles.SYSTEM_ADMIN:
        case Roles.SYSTEM_ADMIN_REGIONAL:
          return (
            <AssetsByUserType
              size="canvas-50"
              widgetItem={{ position: 0, variant: 'default', widget: 'AssetsByUserType' }}
            />
          );
      }
    }
  };

  render() {
    return this.renderWidget();
  }
}
